export var SettingsDialogCategoryToggleClasses;
(function (SettingsDialogCategoryToggleClasses) {
    SettingsDialogCategoryToggleClasses["ON"] = "_on";
    SettingsDialogCategoryToggleClasses["OFF"] = "_off";
    SettingsDialogCategoryToggleClasses["DISABLED"] = "_disabled";
})(SettingsDialogCategoryToggleClasses || (SettingsDialogCategoryToggleClasses = {}));
